import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_disciplines} from "../_signals/s_char";
import {ICharDiscipline} from "../_interfaces/ICharDiscipline";

export interface IDisciplinesUpdate {
    id: string,
    circle: number
}

export const DisciplinesCreate = (create: IDisciplinesUpdate) => {
    fetch(apiAddress + "/char/disciplines/", createOptions('CREATE', create))
        .then((res) => res.json())
        .then((data) => console.log('bedisciplines create response', data))
        .catch((reason => console.log('bedisciplines create catch', reason)))
}

export const DisciplinesUpdate = (update: IDisciplinesUpdate) => {
    fetch(apiAddress + "/char/disciplines/", createOptions('UPDATE', update))
        .then((res) => res.json())
        .then((data) => console.log('bedisciplines update response', data))
        .catch((reason => console.log('bedisciplines update catch', reason)))
}

export const DisciplinesGet = (cid: string) => {
    fetch(apiAddress + "/char/disciplines/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('bedisciplines get result', data.result);
                    s_char_disciplines.value = (data.result as ICharDiscipline[])
                }
            }
        )
        .catch((reason => {
            console.log('bedisciplines get catch', reason);
        }))
}